import React, { useMemo } from 'react';
import { withAreaGetter } from 'providers/AreasConsumers';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import Portal from 'utils/portal/Portal';
import PropTypes from 'prop-types';
import { areas } from 'constants/areas';
import menuConfig from 'constants/menuConfig';
import { useDashboardMenuItem } from 'hooks/useDashboardMenu';
import { Typography } from '@totalsoft/rocket-ui';

const HeaderPortal = props => {
  const { t } = useTranslation();
  const location = useLocation();
  const menuItem = useDashboardMenuItem(location.pathname);

  const pageTitle = useMemo(
    () =>
      t(
        'NavBar.' +
          (menuItem?.name || menuConfig.find(menu => location.pathname.toLowerCase().includes(menu.path.toLowerCase().substring(1)))?.name)
      ),
    [menuItem, location.pathname, t]
  );

  return (
    <Portal container={props.getElemByAreaKey(areas.header)}>
      <Typography noWrap variant='subtitle1' fontWeight='bold' sx={{ pr: 0.5 }}>
        {pageTitle}
      </Typography>
      {props.children}
    </Portal>
  );
};

HeaderPortal.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired,
  children: PropTypes.node
};

export default withAreaGetter(HeaderPortal);
